import { posSystems } from '@biteinc/common';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const SyncableMenuModelSchema = {
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        menuId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        i9nId: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        posId: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        magicCopyKey: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        posFields: {
            type: 'object',
            isReadOnly: true,
            isHidden: true,
            isFreeform: true,
        },
        archivedAt: {
            type: 'timestamp',
            isReadOnly: true,
            isHidden: true,
        },
        integrations: {
            type: 'array',
            isReadOnly: true,
            isHidden: true,
            elementType: 'object',
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                },
                system: {
                    type: 'int',
                    values: posSystems,
                    required: true,
                },
                syncedData: {
                    type: 'object',
                    isFreeform: true,
                },
            },
        },
    },
};
//# sourceMappingURL=syncable_menu_model_schema.js.map